export default function MAXIFY_GX6092() {

    return <>
        <img src="https://image.kr.canon/re/product/2021081916302601_34142108.jpg" alt="GX6092 제품 특징 설명" width="98%" ></img>
        <img src="https://image.kr.canon/re/product/2022041813193101_12619607.jpg" alt="포스터아티스트 설명_1" width="98%"></img>
        <img src="https://image.kr.canon/re/product/2022041813195901_12620608.jpg" alt="포스터아티스트 설명_2" width="98%"></img>
    </>
}